module.exports = __webpack_public_path__ + "assets/icons/ic_history-13e1.svg";